var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section-container section-home" },
    [
      _c("section-code-enel", { attrs: { num: 1 } }),
      _c("section-intro"),
      _c("section-video", { attrs: { num: 2 } }),
      _c("section-features", { attrs: { num: 3 } }),
      _c("section-luciano", { attrs: { num: 4 } }),
      _c("section-partners", { attrs: { num: 5 } }),
      _c("section", { staticClass: "section border-bottom-section" }, [
        _c("div", { staticClass: "section-content" }, [
          _c("div", { staticClass: "columns is-centered is-vcentered" }, [
            _vm._m(0),
            _c("div", { staticClass: "column has-text-centered-md" }, [
              _c(
                "div",
                {
                  staticClass: "title is-spaced",
                  staticStyle: { "margin-bottom": ".5rem" },
                },
                [_vm._v(_vm._s(_vm.$t("about.title_start_workout")))]
              ),
              _c(
                "p",
                {
                  staticClass: "subtitle",
                  staticStyle: { "margin-bottom": ".5rem" },
                },
                [_vm._v(_vm._s(_vm.$t("about.solutions_from")))]
              ),
            ]),
            _c("div", { staticClass: "column is-narrow" }, [
              _c(
                "p",
                {
                  staticClass: "subtitle has-text-centered",
                  staticStyle: { "margin-bottom": ".5rem" },
                },
                [_vm._v(_vm._s(_vm.$t("about.download_app")))]
              ),
              _vm._m(1),
            ]),
          ]),
        ]),
      ]),
      _c("section-form", { ref: "sectionform" }),
      _c(
        "modal-comp",
        {
          ref: "modalvideo",
          staticClass: "modal-video",
          attrs: { title: _vm.$t("menu.video") },
          on: { close: _vm.videoPopupClosed },
        },
        [
          _vm.videoPopup
            ? _c("div", { staticClass: "columns is-centered is-vcentered" }, [
                _c(
                  "video",
                  {
                    ref: "playervideo",
                    attrs: { width: "854", height: "480", controls: "" },
                  },
                  [
                    _c("source", {
                      attrs: {
                        src: "/videos/workout-ita.mp4",
                        type: "video/mp4",
                      },
                    }),
                    _vm._v(_vm._s(_vm.$t("home.no_video_support"))),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow has-text-centered" }, [
      _c("img", {
        staticStyle: { width: "100px", display: "inline-block" },
        attrs: { src: "/icon.png" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "app-container justify-center-md",
        staticStyle: { "justify-content": "flex-end" },
      },
      [
        _c(
          "a",
          {
            staticStyle: { "max-width": "140px" },
            attrs: {
              href: "https://play.google.com/store/apps/details?id=com.fitnessdadivano.app",
              target: "_blank",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "/img/google_play_badge.svg",
                alt: "Android",
                title: "Android",
              },
            }),
          ]
        ),
        _c(
          "a",
          {
            staticStyle: { "max-width": "140px" },
            attrs: {
              href: "https://itunes.apple.com/it/app/id1531130588?mt=8",
              target: "_blank",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "/img/app_store_badge.svg",
                alt: "iOS",
                title: "iOS",
              },
            }),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }